import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { protectSheetWithRandomPassword } from './ExcelUtils';

export const exportSocialBenefitExcel = async ({ data, date, fileName = "Social_Benefit.xlsx", loginPlaceId = null }) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Social Benefit Report');

    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
    const reportMonth = date ? monthNames[new Date(date).getMonth()] : "";

    worksheet.mergeCells('A1:L1');
    const title = worksheet.getCell('A1');
    title.value = `Bank Progress of Crediting Prosperity Subsidy and Social Benefits to Accounts`;
    title.font = { bold: true, size: 14 };
    title.alignment = { vertical: 'middle', horizontal: 'center' };

    worksheet.mergeCells('A2:L2');
    const subtitle = worksheet.getCell('A2');
    subtitle.value = `Month of ${reportMonth}`;
    subtitle.font = { bold: true, size: 12 };
    subtitle.alignment = { vertical: 'middle', horizontal: 'center' };

    const headerRow = [
        "Index",
        "Bank",
        "",
        "",
        "Prosperity Allowances",
        "Adult Allowances",
        "Disability Allowances",
        "Kidney Patient Allowances",
        "Centennial Allowances",
        "Allowances for Pregnant and Lactating",
        "Total"
    ];

    worksheet.getRow(4).values = headerRow;

    const columnsToMerge = ['A', 'B', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
    columnsToMerge.forEach(col => {
        worksheet.mergeCells(`${col}4:${col}5`);
    });
    worksheet.mergeCells('C4:D5');

    worksheet.getRow(4).eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
            top: { style: 'thin' }, left: { style: 'thin' },
            bottom: { style: 'thin' }, right: { style: 'thin' }
        };
    });

    let currentRow = 6;

    data.forEach((item) => {
        const headOfficeBaseRow = currentRow;
        const beneficiaryBaseRow = headOfficeBaseRow + 2;

        // Define rows
        const headOfficeCountRow = worksheet.getRow(headOfficeBaseRow);
        const headOfficeAmountRow = worksheet.getRow(headOfficeBaseRow + 1);
        const beneficiaryCountRow = worksheet.getRow(beneficiaryBaseRow);
        const beneficiaryAmountRow = worksheet.getRow(beneficiaryBaseRow + 1);

        // --- Head Office Count Row ---
        headOfficeCountRow.values = [
            item.brnchId,
            item.brnchNme,
            "Amount Credited by Head Office",
            "Count",
            item.prosperityHeadCount,
            item.adultHeadCount,
            item.disabilityHeadCount,
            item.kidneyHeadCount,
            0,
            item.pregnantHeadCount,
            (item.prosperityHeadCount + item.adultHeadCount + item.disabilityHeadCount + item.kidneyHeadCount + item.pregnantHeadCount)
        ];
        for (let col = 5; col <= 11; col++) headOfficeCountRow.getCell(col).numFmt = '0';

        // --- Head Office Amount Row ---
        headOfficeAmountRow.values = [
            "", "", "", "Amount Rs.",
            item.prosperityHeadAmount,
            item.adultHeadAmount,
            item.disabilityHeadAmount,
            item.kidneyHeadAmount,
            0,
            item.pregnantHeadAmount,
            (item.prosperityHeadAmount + item.adultHeadAmount + item.disabilityHeadAmount + item.kidneyHeadAmount + item.pregnantHeadAmount)
        ];
        for (let col = 5; col <= 11; col++) headOfficeAmountRow.getCell(col).numFmt = '#,##0.00';

        // --- Beneficiary Count Row ---
        beneficiaryCountRow.values = [
            "", "", "Amount Credited to Beneficiary Accounts", "Count",
            item.prosperityBenefitCount,
            item.adultBenefitCount,
            item.disabilityBenefitCount,
            item.kidneyBenefitCount,
            0,
            item.pregnantBenefitCount,
            (item.prosperityBenefitCount + item.adultBenefitCount + item.disabilityBenefitCount + item.kidneyBenefitCount + item.pregnantBenefitCount)
        ];
        for (let col = 5; col <= 11; col++) beneficiaryCountRow.getCell(col).numFmt = '0';

        // --- Beneficiary Amount Row ---
        beneficiaryAmountRow.values = [
            "", "", "", "Amount Rs.",
            item.prosperityBenefitAmount || 0,
            item.adultBenefitAmount || 0,
            item.disabilityBenefitAmount || 0,
            item.kidneyBenefitAmount || 0,
            0,
            item.pregnantBenefitAmount || 0,
            (
                (item.prosperityBenefitAmount || 0) +
                (item.adultBenefitAmount || 0) +
                (item.disabilityBenefitAmount || 0) +
                (item.kidneyBenefitAmount || 0) +
                (item.pregnantBenefitAmount || 0)
            )
        ];
        for (let col = 5; col <= 11; col++) beneficiaryAmountRow.getCell(col).numFmt = '#,##0.00';

        // --- Merge Cells ---
        worksheet.mergeCells(`A${headOfficeBaseRow}:A${beneficiaryBaseRow + 1}`);
        worksheet.mergeCells(`B${headOfficeBaseRow}:B${beneficiaryBaseRow + 1}`);
        worksheet.mergeCells(`C${headOfficeBaseRow}:C${headOfficeBaseRow + 1}`);
        worksheet.mergeCells(`C${beneficiaryBaseRow}:C${beneficiaryBaseRow + 1}`);

        currentRow += 4;
    });

    // Final Formatting
    worksheet.columns.forEach(column => {
        column.width = 15;
        column.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    });
    worksheet.getColumn(3).width = 25;

    worksheet.eachRow((row, rowNumber) => {
        if (rowNumber >= 4) {
            row.eachCell(cell => {
                cell.border = {
                    top: { style: 'thin' }, left: { style: 'thin' },
                    bottom: { style: 'thin' }, right: { style: 'thin' }
                };
            });
        }
    });

    if (loginPlaceId === "1") {
        protectSheetWithRandomPassword(worksheet, 12);
    }

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), fileName);
};
